import { getFromAPI } from '@/lib/api';
import { CollectionCompleteVideoAttributes, StrapiAPIResponseSingle } from '@/lib/apiTypes';
import { useEffect, useState } from 'react';
import useKeyValueStorage from './storage/useKeyValueStorage';
import useVideo from './useVideo';

const useCollectionCompleteVideo = () => {
    const { value: collectionCompleteVideo, setValue: setCollectionCompleteVideo } = useKeyValueStorage<
        CollectionCompleteVideoAttributes | undefined
    >('collectionCompleteVideo', undefined);

    const { audioDescriptionFile, subtitlesBase64, isError } = useVideo({
        video: collectionCompleteVideo?.video,
    });

    const [collectionCompleteVideoError, setCollectionCompleteVideoError] = useState<boolean>(false);
    const { value: hasSeenCollectionCompleteVideo, setValue: setHasSeenCollectionCompleteVideo } =
        useKeyValueStorage('hasSeenCollectionCompleteVideo', false);

    useEffect(() => {
        getFromAPI('collection-complete-video')
            .then((data) => {
                const collectionVideoAttributes = (
                    data as StrapiAPIResponseSingle<CollectionCompleteVideoAttributes>
                ).data.attributes;
                setCollectionCompleteVideo(collectionVideoAttributes);
            })
            .catch(() => {
                setCollectionCompleteVideoError(true);
            });
    }, [setCollectionCompleteVideo]);

    return {
        collectionCompleteVideo: collectionCompleteVideo,
        collectionCompleteVideoSubtitlesBase64: subtitlesBase64,
        collectionCompleteVideoAudioDescriptionFile: audioDescriptionFile,
        isLoadingCollectionCompleteVideo: !collectionCompleteVideo && !hasSeenCollectionCompleteVideo && !collectionCompleteVideoError,
        isError: !!collectionCompleteVideoError || !!isError,
        hasSeenCollectionCompleteVideo,
        setHasSeenCollectionCompleteVideo,
    };
};

export default useCollectionCompleteVideo;
